import { boolean, object, string, type infer as zInfer } from "zod";

export const getParentEasypostIntegration = {
  name: "getParentEasypostIntegration" as const,
  input: object({}),
  output: object({
    integration: object({
      _id: string(),
      enabled: boolean(),
      accountId: string().optional(),
    }).optional(),
  }),
};

export type GetParentEasypostIntegrationOutput = zInfer<
  typeof getParentEasypostIntegration.output
>;
